'use client';
import { FunctionComponent, useCallback } from 'react';
import { CheckoutState, OriginString } from '@shared/types';
import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Checkout } from '../../../../../components/Checkout';

export type ClientCheckoutProps = {
    course: PublicCourse;
    educator: PublicEducator;
    origin: OriginString;
    flow: CheckoutState['flow'];
    occurrenceId: string | null;
    checkoutId: string | null;
};

export const ClientCheckout: FunctionComponent<ClientCheckoutProps> = ({
    course,
    educator,
    origin,
    flow,
    occurrenceId,
    checkoutId,
}) => {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const onCheckoutIdChange = useCallback(
        (checkoutId: string) => {
            const newParams = new URLSearchParams(searchParams || {});
            newParams.set('checkout_id', checkoutId);
            newParams.toString();
            router.replace(`${pathname}?${newParams.toString()}`);
        },
        [router, pathname, searchParams]
    );

    return (
        <Checkout
            checkoutId={checkoutId || undefined}
            course={course}
            origin={origin}
            educator={educator}
            flow={flow}
            occurrenceId={occurrenceId || undefined}
            onCheckoutIdChange={onCheckoutIdChange}
        />
    );
};
